import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

// A mirrored pair of megaphones: the scene stays symmetric in LTR and RTL.
const SIDES = [
  "translate(100 96) rotate(-40) scale(.85)",
  "translate(60 96) scale(-1 1) rotate(-40) scale(.85)",
] as const;

export function BroadcastsIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path d="M66 58Q80 48 94 58M56 46Q80 28 104 46" stroke={c.a400} strokeWidth="4" />
      {SIDES.map((transform) => (
        <g key={transform} transform={transform}>
          <rect x="-6" y="8" width="10" height="22" rx="4" fill={c.a400} />
          <rect x="-22" y="-11" width="16" height="22" rx="6" fill={c.p700} />
          <path d="M-8-10L30-26V26L-8 10Z" fill={c.p500} />
          <path d="M8-13V13" stroke={c.a300} strokeWidth="5" />
          <ellipse cx="30" rx="6" ry="26" fill={c.p300} />
          <ellipse cx="31" rx="3.5" ry="19" fill={c.p700} />
        </g>
      ))}
    </Frame>
  );
}
